/**
 * LogoLockup.tsx — Marken-Lockup für den AppShell-`logo`-Slot.
 *
 * CONUTI „Circle-Dot"-Marke (Zielscheiben-Motiv aus dem conuti-design-System,
 * assets/brand/circle_dot_white.svg) inline eingebettet mit `fill="currentColor"`,
 * damit die Marke der Textfarbe (`--prn-label`) folgt — weiß auf cu-dark, dunkel
 * auf cu-light. Daneben die tracked-uppercase-Wortmarke in der CI-Hausschrift
 * (Cabinet Grotesk unter den cu-Themes via `--prn-font`).
 *
 * viewBox 1:1 aus dem Quell-SVG (2000×2000) übernommen.
 */

const ConutiDot = ({ size = 22 }: { size?: number }) => (
  <svg
    viewBox="0 0 2000 2000"
    width={size}
    height={size}
    aria-hidden="true"
    focusable="false"
    style={{ display: "block", flex: "0 0 auto" }}
  >
    <path
      fill="currentColor"
      d="M1141.51,483.28c-11.14-3.05-22.41-5.78-33.83-8.12-34.89-7.14-71.02-10.89-108.03-10.89-25.01,0-49.6,1.75-73.7,5.06-261.26,35.92-462.51,260.01-462.51,531.14s203.07,497.27,466.05,531.64c22.96,3,46.37,4.57,70.15,4.57,38.26,0,75.57-4.04,111.56-11.66,11.38-2.41,22.62-5.16,33.72-8.28,225.54-63.34,390.92-270.49,390.92-516.27s-167.06-455-394.35-517.2ZM1096.96,1315.3c-11.3,3.49-22.87,6.37-34.65,8.64-20.29,3.91-41.22,5.98-62.65,5.98-41.63,0-81.44-7.74-118.11-21.83-123.59-47.49-211.32-167.29-211.32-307.6s86.77-258.82,209.29-306.83c37.22-14.59,77.74-22.6,120.13-22.6,20.65,0,40.85,1.92,60.45,5.56,11.83,2.19,23.44,5.02,34.79,8.45,135.5,40.86,234.18,166.61,234.18,315.43s-97.69,273.31-232.13,314.82Z"
    />
    <path
      fill="currentColor"
      d="M1038.96,841.36c-20.51-5.07-34.89-6.13-57.3-4.02-52.44,4.44-102.77,38.48-127.51,86.06-14.59,28.33-18.19,43.56-18.19,77.39,0,25.16.85,31.93,4.86,45.46,18.61,59,63.44,101.5,121.37,115.24,19.67,4.65,56.46,4.02,76.97-1.06,33.83-8.46,67.67-30.24,88.81-56.67,12.26-15.44,27.28-45.89,31.72-64.92,5.29-21.15,4.65-58.57-.85-79.51-15.86-58.78-61.53-103.82-119.89-117.99Z"
    />
  </svg>
);

/**
 * Marken-Lockup: CONUTI-Circle-Dot + „MACO PIPELINE". Tracked-uppercase-Wortmarke
 * in der CI-Hausschrift.
 */
export function LogoLockup({ dotSize = 22 }: { dotSize?: number }) {
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 9,
        color: "var(--prn-label)",
        lineHeight: 1,
      }}
    >
      <ConutiDot size={dotSize} />
      <span
        style={{
          fontFamily: "var(--prn-font)",
          fontSize: 14,
          fontWeight: 700,
          letterSpacing: "0.14em",
          textTransform: "uppercase",
          whiteSpace: "nowrap",
        }}
      >
        MACO&nbsp;PIPELINE
      </span>
    </span>
  );
}

export default LogoLockup;
